"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFICATION_SHOW = exports.NOTIFICATION_HIDE = exports.ALL_NOTIFICATIONS_HIDE = void 0;
var NOTIFICATION_SHOW = '@frontend/common/components/Notifications/NOTIFICATION_SHOW';
exports.NOTIFICATION_SHOW = NOTIFICATION_SHOW;
var NOTIFICATION_HIDE = '@frontend/common/components/Notifications/NOTIFICATION_HIDE';
exports.NOTIFICATION_HIDE = NOTIFICATION_HIDE;
var ALL_NOTIFICATIONS_HIDE = '@frontend/common/components/Notifications/ALL_NOTIFICATIONS_HIDE';
exports.ALL_NOTIFICATIONS_HIDE = ALL_NOTIFICATIONS_HIDE;